// extracted by mini-css-extract-plugin
module.exports = {"container":"_18WjH5QIY-VlkiDDzl2Cpm"};